import React from 'react';
import { AppComponent } from '../AppComponent';
import { PageContent, PageStyle } from '../layout/PageContent/PageContent';
import { THtml } from '../widget/display/THtml';
import { Redirect, RouteComponentProps, withRouter } from 'react-router-dom';
import BankIdLogin from './BankIdLogin';
import './LoginPage.scss';
import { Heading } from '../widget/display/Heading/Heading';
import { InfoBox, InfoBoxIcon } from '../widget/display/InfoBox/InfoBox';


interface Props extends RouteComponentProps<any>{
}

class LoginPage extends AppComponent<Props> {
	sessionService = this.application.services.sessionService;
	textService = this.application.services.textService;

	constructor(props: Props) {
		super(props);
	}

	render() {
		const isLoggedIn = this.sessionService.isLoggedIn();
		if (isLoggedIn) 
			return <Redirect to="/" />
			let infoTextKey = 'Login_InfoMessage';
			let warningTextKey = 'Login_WarningMessage';

			let showInfoMessage = this.textService.nilsEmptyOrDefault(infoTextKey, '') !== '';
			let showWarningMessage = this.textService.nilsEmptyOrDefault(warningTextKey, '') !== '';

		return (
			<div className="Page LoginPage">
				<PageContent style={PageStyle.Gray}>
					<div className="Login">
						<InfoBox 
							icon={InfoBoxIcon.info} 
							visible={showInfoMessage}
							className={showInfoMessage && showWarningMessage ? 'margin-bottom-small' : 'margin-bottom'} 
							textkey={infoTextKey} />
						<InfoBox 
							icon={InfoBoxIcon.warning} 
							visible={showWarningMessage}
							className='margin-bottom'
							textkey={warningTextKey} />
						<Heading level={1} labelTextkey="Login_LoginTitle"/>
						<p>
							<THtml k="Login_LoginDescription" />
						</p>
						<BankIdLogin />
					</div>
					<aside className="Content">
						<Heading level={2} labelTextkey="Login_Content_Title"/>
						<p>
							<THtml k="Login_Content_Description" />
						</p>
					</aside>
				</PageContent>
			</div>
		);
	}
}

export default withRouter(LoginPage);
